import React, {Component} from 'react'
import Icon from "../common/icon/icon.component.jsx";

class CreditCardLabel extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            card: this.props.value || {},
            className: this.props.className || '',
        }
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            card: nextProps.value || {},
            className: nextProps.className || '',
        })
    }

    componentDidMount() {}



    render() {
        if (!this.state.card) {
            return ''
        }
        return <span>
            <Icon value={'credit-card'} className={'mr-1'} />
            {this.state.card.attributes.brand.toUpperCase()}
            <Icon value={'ellipsis-h'} className={'ml-3'} />
            <Icon value={'ellipsis-h'} />
            <Icon value={'ellipsis-h'} />
            {this.state.card.attributes.last4}
        </span>
    }

}

export default CreditCardLabel





// WEBPACK FOOTER //
// ./src/payment/creditcard.component.jsx